/** ***********************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ************************************************************************* */

import React, {Component} from 'react';
import GlobalUtils, {Utils} from '../../../../../utils/Globals';
import getConfig from '../../../../../config';
import DropZone from '@react/react-spectrum/DropZone';
import './EmptyState.scss';
import {RecentAssetsAnalytics} from 'recent-files';
import {addToast, Toast} from '@react/react-spectrum/Toast';

const allowedExtensionArr = ['.PSD', '.PSB', '.HEIC', '.JPG', '.PNG', '.TIFF', '.TIF', '.JPEG'];
class ImportFile {
	static _instance: any;
	fileSelector: any;

	constructor() {
		if (ImportFile._instance) {
			return ImportFile._instance;
		}
		ImportFile._instance = this;
		this.fileSelector = this.buildFileSelector();
	}

	handleFileSelect = (e, src) => {
		e && e.preventDefault();
		if (src === 'select') {
			const analytics = new RecentAssetsAnalytics();
			analytics.postEmptyPageClick('select');
		}
		this.fileSelector.click();
	};

	dropAction(e) {
		const targetHostname = getConfig('PHOTOSHOP_WEB');
		const files = e.target.files || e.dataTransfer.files;
		// console.log( e.target.files || e.dataTransfer.files);
		if (files.length > 0) {
			if (allowedExtensionArr.indexOf(`.${files[0].name.split('.').pop()
				.toUpperCase()}`) > -1) {
				const analytics = new RecentAssetsAnalytics();
				analytics.postDropFileEvent();
				const response = GlobalUtils.setToProxyFrame(targetHostname, files);
				if (response instanceof Error) {
					addToast(
						<Toast closable variant='error'>
							{Utils.localizedStrings['appHomes.error.modal.psweb.title']}
						</Toast>,
						3000,
					);
				}
			}
			else {
				addToast(
					<Toast closable variant='error'>
						{Utils.localizedStrings['recents.psweb.unsupportedFormat.msg']}
					</Toast>,
					3000,
				);
			}
		}
	}

	buildFileSelector() {
		const fileSelector = document.createElement('input');
		fileSelector.setAttribute('type', 'file');
		fileSelector.setAttribute('accept', allowedExtensionArr.join(','));
		fileSelector.onchange = this.dropAction;
		return fileSelector;
	}
}

export const importFileObj = new ImportFile();

/*
 * PSWebEmptyState is the view displayed in the UI when empty(s) occur.
 */
class PSWebEmptyState extends Component {
	componentDidMount() {
		this.addEventListenerToElemId('empty-state-psweb-select-one', 'click', (e) => {
			importFileObj.handleFileSelect(e, 'select');
		});
	}

	addEventListenerToElemId(elemId: string, eventType: string, callback: EventListenerOrEventListenerObject) {
		const elem = document.getElementById(elemId);
		if (elem) {
			elem.addEventListener(eventType, callback);
		}
	}

	render() {
		return (
			<DropZone
				className='empty-state-app-home empty-state-psweb-container'
				dropEffect='copy'
				label={Utils.localizedStrings['recents.psweb.emptystate.label']}
				role='region'
				onDrop={importFileObj.dropAction}
			>
				<img style={{width: '160px'}} src='/assets/common/PSDrop.svg' />
				<h2
					className='empty-state-psweb-heading'
					dangerouslySetInnerHTML={{__html: Utils.localizedStrings['recents.psweb.emptystate.heading']}}
				/>
				<div
					className='empty-state-psweb-description'
					dangerouslySetInnerHTML={{__html: Utils.localizedStrings['recents.psweb.emptystate.description']}}
				/>
			</DropZone>
		);
	}
}

export default PSWebEmptyState;
